import React from 'react';

function LevelScoreContainer(props) {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
        }}>
            {props.children}
        </div>
    );
}

export default LevelScoreContainer;
